//#endregion Start CTA Subscribe Form

import JustValidate from './../../node_modules/just-validate';

const subValidate = new JustValidate('#cta-subscribe-form');

subValidate
	.addField('#success-fullname-cta', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
			errorMessage: 'Enter Full Name',
		},
		{
			rule: 'customRegexp',
			value: /^[a-zA-Z]+ [a-zA-Z]+$/,
			errorMessage: 'Enter Full Name',
		},
	])
	.addField('#success-companyemail-cta', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	]);

//#region Start CTA Subscribe Form

let Googlesubscribe_SendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global_subscribe = document.querySelector('.loading-div');

document
	.querySelector('#cta-subscribe-form')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (subValidate.isValid == false) {
			return false;
		} else {
			console.log(subValidate.isValid);
		}

		loading_global_subscribe.classList.add('active');

		let formData = new FormData(event.target);
		let fullName = formData.get('lfirstname').split(' ');
		let firstName, lastName;
		[firstName, ...lastName] = fullName;
		lastName = lastName.join(' ');
		formData.set('lfirstname', firstName);
		formData.set('llastname', lastName);
		formData.append('sendurlvalue', window.location.href);
		formData.append('lsource', 'SS-News-Letter-Form-CTA');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			firstName: formData.get('lfirstname'),
			lastName: formData.get('llastname'),
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);
		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			Googlesubscribe_SendURL + request,
			googleRequestOptions,
		);
		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}
		// Redirect
		window.location.href = 'https://cyntexa.com/success?msg=newsletter';
	});

//#endregion Start CTA Subscribe Form
